module.exports = __webpack_public_path__ + "img/poster.8b9d8c65.jpg";